import React, { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './index.scss';
import { Provider } from 'react-redux';
import store from './store/index';

const root_div = document.getElementById('calender_root');

if (root_div) {
  const Events = lazy(() => import('./components/Events'));
  const root = ReactDOM.createRoot(root_div);
  root.render(
    <Provider store={store}>
      <Events />
    </Provider>
  );
}
